import { createReducer } from '../../../utilities';
import {
    SUCCESS_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM
} from "../../../../actions/entities/statistics/players";

const initialState = {};

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        ...data,
    };
}

export default createReducer(initialState, {
    [SUCCESS_FETCH_STATS_PLAYERS_NUMBER_IN_TEAM]: successFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/players/numberInTeam.js